module.exports = __webpack_public_path__ + "img/header-bg.5d1f9c86.png";